import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminTeacherVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveTeacher = createAsyncThunk<AdminTeacherVM, string, { extra: Partial<Dependencies> }>(
  "teachers/retrieveTeacher",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getTeacher(id);
  },
);
